(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  (() => {
    const initialisePhoneModals = (root = document) => {
      root.querySelectorAll('[data-footer-phone-modal]').forEach((modal) => {
        if (modal.dataset.phoneModalInitialised === 'true') return;
        modal.dataset.phoneModalInitialised = 'true';

        const callButton = modal.querySelector('[data-footer-phone-call]');
        const closeButtons = modal.querySelectorAll('[data-footer-phone-close]');
        let lastTrigger = null;

        const closeModal = () => {
          if (typeof modal.close === 'function') {
            modal.close();
          } else {
            modal.removeAttribute('open');
          }
        };

        document.querySelectorAll('[data-footer-phone-trigger]').forEach((trigger) => {
          if (trigger.getAttribute('aria-controls') !== modal.id) return;

          trigger.addEventListener('click', () => {
            const phone = trigger.dataset.phone;
            const phoneDisplay = trigger.dataset.phoneDisplay || phone;

            callButton.href = `sms:${phone}?&body=Hi Nursery Near Me, I would like help with: %0A%0APlants or order number: %0APostcode: %0ABest time to call: `;
            const callButtonText = callButton.querySelector('span');
            if (callButtonText) {
              callButtonText.textContent = `Text ${phoneDisplay}`;
            } else {
              callButton.textContent = `Text ${phoneDisplay}`;
            }
            lastTrigger = trigger;

            if (typeof modal.showModal === 'function') {
              modal.showModal();
            } else {
              modal.setAttribute('open', '');
            }
          });
        });

        closeButtons.forEach((button) => {
          button.addEventListener('click', closeModal);
        });

        modal.addEventListener('click', (event) => {
          if (event.target === modal) closeModal();
        });

        modal.addEventListener('close', () => {
          if (lastTrigger) lastTrigger.focus();
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialisePhoneModals());
    } else {
      initialisePhoneModals();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initialisePhoneModals(event.target);
    });
  })();

  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-backup"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if (this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();
})();
